import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { TagRequest, TagResponse } from '@builtbybros/al-model';
import moment = require('moment');
import { TagService } from '../tag.service';
import { FormsService } from '../../../shared/forms.service';
import {AlertService} from '../../../shared/alert.service';

@Component({
  selector: 'app-tag-form',
  templateUrl: './tag-form.component.html',
  styleUrls: ['./tag-form.component.scss']
})
export class TagFormComponent implements OnInit {

  tagId: number;
  tagForm: FormGroup;
  btnMsg: string;
  h1: string;
  feedBackMsg: string;
  msg = {
    'updateError': 'Hubo un error al actualizar la etiqueta',
    'updateSuccess': 'Etiqueta actualizada correctamente',
    'createError': 'Hubo un error al crear la etiqueta',
    'createSuccess': 'Etiqueta creada correctamente',
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private formsService: FormsService,
    private alertService: AlertService,
    private tagService: TagService) {
    this.createFormGroup();
  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (params['tagId']) {
        // Update tag
        // Get the tag with id = PromoId
        this.h1 = 'Editar Etiqueta';
        this.btnMsg = 'Actualizar';
        this.tagId = +params['tagId'];
        this.feedBackMsg = '';

        this.tagService.getTag(params['tagId'])
          .subscribe(
            tagResponse => {
              this.tagForm.patchValue(tagResponse);
            }
          );
      } else {
        // Create tag
        this.h1 = 'Crear Etiqueta';
        this.btnMsg = 'Crear';
      }
    });
  }

  submitForm() {
    if (this.formsService.validateFormAndUpdateErrors(this.tagForm)) {
      if (this.tagId) {
        // Update tag
        const tag = new TagRequest.Update();
        tag.parse(this.tagForm.value);
        this.tagService.updateTag(this.tagId, tag)
          .subscribe(
            createResponse => {
              console.log(`Create Menu - Parsed:`, createResponse);
            },
            error => {
              this.alertService.error(this.msg['updateError']);
            },
            () => {
              this.alertService.success(this.msg['updateSuccess']);
            }
          );
      } else {
        const tag = new TagRequest.Create();
        // Create tag
        tag.parse(this.tagForm.value);
        this.tagService.createTag(tag)
          .subscribe(
            createResponse => {
              console.log(`Create Menu - Parsed:`, createResponse);
            },
            () => {
              this.alertService.success(this.msg['createSuccess']);
            }
          );
      }
    }
    return;
  }

  private createFormGroup() {
    this.tagForm = this.fb.group({
      'name': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'section': [
        ''
      ]
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/tags/shared/tag-form/tag-form.component.ts